<div nz-row class=" overflow-hidden w-full">
  <div nz-col nzSpan="24" nzMd="14"
    class="bg-primary-500 h-[100vh] py-4 px-4 md:px-8 lg:px-16 flex flex-col justify-between items-start relative"
    [style]="{ 'background-image': 'url(assets/svgs/auth-bg.svg)', 'background-size': 'cover', 'background-position': 'center' }">
    <img [ngSrc]="'assets/images/splash-shape-left.png'" class="absolute top-0 left-0" priority width="200"
      height="200" />

    <div class="relative z-10 space-y-6 mt-12 md:mt-20 lg:mt-32">
      <svg-icon src="assets/svgs/logo.svg"></svg-icon>

      <h4 class="text-2xl font-semibold text-white">Visitor Management System</h4>
      <h1 class="text-5xl font-bold text-white">For Modern Facilities & Workplaces</h1>
      <p class="text-xl text-[#F2F2F2CC]">Check-ins, enhance security, and make a lasting first impression</p>

      <div class="flex flex-wrap gap-5">
        <span class="flex gap-4 rounded-2xl p-4 bg-[#164139] w-[280px]">
          <svg-icon src="assets/svgs/check-circle.svg"></svg-icon>
          <p class="text-white font-bold">Instant Visitor Check in</p>
        </span>

        <span class="flex gap-4 rounded-2xl p-4 bg-[#164139] w-[280px]">
          <svg-icon src="assets/svgs/check-circle.svg"></svg-icon>
          <p class="text-white font-bold">Advanced Security</p>
        </span>

        <span class="flex gap-4 rounded-2xl p-4 bg-[#164139] w-[280px]">
          <svg-icon src="assets/svgs/check-circle.svg"></svg-icon>
          <p class="text-white font-bold">Digital Visitor Log in</p>
        </span>

        <span class="flex gap-4 rounded-2xl p-4 bg-[#164139] w-[280px]">
          <svg-icon src="assets/svgs/check-circle.svg"></svg-icon>
          <p class="text-white font-bold">Real time notification</p>
        </span>
      </div>
    </div>

    <span class="bg-white/5 px-4 py-2 rounded-lg">
      <p class="text-white">In compliance with <a class="text-white font-semibold" href="https://ndpc.gov.ng/">NIGERIA
          DATA PROTECTION
          COMMISSION</a></p>
    </span>

    <img [ngSrc]="'assets/svgs/spiral-arrow-right.svg'" class="absolute bottom-32 right-10" priority width="225"
      height="200" />

    <img [ngSrc]="'assets/images/splash-shape-right.png'" class="absolute bottom-0 -right-[110px]" priority width="200"
      height="200" />
  </div>

  <div nz-col nzSpan="24" nzMd="10" class="bg-white h-[100vh] overflow-y-auto flex items-center">
    <div class="w-full py-4 px-4 flex flex-col items-center">
      <!-- <nz-tabset nzLinkRouter class="w-full sticky top-[-1px] z-20 bg-white" nzSize="large" nzCentered>
        <nz-tab>
          <a *nzTabLink nz-tab-link [routerLink]="['/auth/setup']" class="px-16">
            Setup
          </a>
        </nz-tab>
        <nz-tab>
          <a *nzTabLink nz-tab-link [routerLink]="['/auth/login']" class="px-16">
            Login
          </a>
        </nz-tab>
      </nz-tabset> -->

      <router-outlet></router-outlet>
    </div>

  </div>
</div>